import { render, staticRenderFns } from "./WineryContact_Mobile.vue?vue&type=template&id=ab4927d2&"
import script from "./WineryContact_Mobile.vue?vue&type=script&lang=js&"
export * from "./WineryContact_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports